export default __webpack_public_path__ + "static/media/trampapo-logo-inverse.711b5902.png";